//Set the number of days before your cookie should expire
const ExpireDays = 90;

export default function setCookies() {
    //Do not change anything below this line
    let qstr = document.location.search;
    qstr = qstr.substring(1, qstr.length);
    function SetCookie(cookieName, cookieValue, nDays) {
        var today = new Date();
        var expire = new Date();
        if (nDays == null || nDays == 0) nDays = 1;
        expire.setTime(today.getTime() + 3600000 * 24 * nDays);
        document.cookie =
            cookieName +
            "=" +
            escape(cookieValue) +
            "; expires=" +
            expire.toGMTString() +
            "; path=/";
    }
    const thevars = qstr.split("&");
    for (let i = 0; i < thevars.length; i++) {
        const cookiecase = thevars[i].split("=");
        switch (cookiecase[0]) {
            case "sfmc_sub":
                const sfmc_sub = cookiecase[1];
                SetCookie("SubscriberID", sfmc_sub, ExpireDays);
                break;
            case "e":
                const e = cookiecase[1];
                SetCookie("EmailAddr_", e, ExpireDays);
                break;
            case "j":
                const j = cookiecase[1];
                SetCookie("JobID", j, ExpireDays);
                break;
            case "l":
                const l = cookiecase[1];
                SetCookie("ListID", l, ExpireDays);
                break;
            case "jb":
                const jb = cookiecase[1];
                SetCookie("BatchID", jb, ExpireDays);
                break;
            case "u":
                const u = cookiecase[1];
                SetCookie("UrlID", u, ExpireDays);
                break;
            case "mid":
                const mid = cookiecase[1];
                SetCookie("MemberID", mid, ExpireDays);
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sales-force-cookie/sales-force-cookie.js